/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Hub_HintInputs */

const en_us2_coaching_hub_hint = /** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations, your trainer, your groups and templates`)
};

const pt_br2_coaching_hub_hint = /** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convites, seu personal, suas turmas e modelos`)
};

const pt_pt2_coaching_hub_hint = /** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convites, seu personal, suas turmas e modelos`)
};

/** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */
const es_419_coaching_hub_hint = en_us2_coaching_hub_hint;

/** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */
const fr_fr2_coaching_hub_hint = en_us2_coaching_hub_hint;

/** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */
const de_de2_coaching_hub_hint = en_us2_coaching_hub_hint;

/** @type {(inputs: Coaching_Hub_HintInputs) => LocalizedString} */
const it_it2_coaching_hub_hint = en_us2_coaching_hub_hint;

/**
* | output |
* | --- |
* | "Invitations, your trainer, your groups and templates" |
*
* @param {Coaching_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_hub_hint = /** @type {((inputs?: Coaching_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_hub_hint(inputs)
	if (locale === "es-419") return es_419_coaching_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_coaching_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_coaching_hub_hint(inputs)
	return en_us2_coaching_hub_hint(inputs)
});
export { coaching_hub_hint as "coaching.hub_hint" }